import { Component, Input, OnInit } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DataViewModule } from 'primeng/dataview';
import { DividerModule } from 'primeng/divider';
import { DialogModule } from 'primeng/dialog';
import { CurrencyPipe, NgClass } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';
import { NgxAimStationOverviewClass } from './ngx-aim-station-checkout-overview.class';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { FloatLabelModule } from 'primeng/floatlabel';

@Component({
  selector: 'ngx-aim-station-checkout-overview',
  standalone: true,
  imports: [
    ButtonModule,
    DataViewModule,
    DividerModule,
    DialogModule,
    CurrencyPipe,
    NgClass,
    FormsModule,
    CheckboxModule,
    InputTextareaModule,
    FloatLabelModule,
  ],
  templateUrl: './ngx-aim-station-checkout-overview.component.html',
  styleUrl: './ngx-aim-station-checkout-overview.component.css'
})
export class NgxAimStationCheckoutOverviewComponent extends NgxAimStationOverviewClass implements OnInit {
  @Input()
  override notesMessage = 'Enter notes here';

  ngOnInit() {
    this.init();
  }
}
